import { forwardRef, IconProps as ChakraIconProps } from '@chakra-ui/react';
import * as bigIcons from '../Icons/24x24';
import * as smallIcons from '../Icons/16x16';

export type TypeIconName = keyof typeof bigIcons | keyof typeof smallIcons;
export interface IconProps extends ChakraIconProps {
  name: TypeIconName;
  size?: '16' | '24' | '32';
}

const Icon = forwardRef<IconProps, 'svg'>(({ name, size = '24', ...rest }, ref) => {
  const props = {
    height: size,
    ref,
    width: size,
    ...rest,
  };
  const ThisIcon = size === '16' ? smallIcons[name as keyof typeof smallIcons] : bigIcons[name];
  return <ThisIcon {...props} />;
});

export default Icon;
